import React, { useState, useContext } from "react";
import axios from "axios";
import { FormContext } from "../../context/FormContext"; 

const ReagendamientoReserva = ({ datosReserva, prevStep, nextStep }) => {
  // Datos de la reserva recibidos para reagendamiento
  // console.log("Received datosReserva prop:", datosReserva);
   const {formData} = useContext(FormContext)
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupVariant, setPopupVariant] = useState("success");
  const [isLoading, setIsLoading] = useState(false);

  const { data: reservaData, status: reservaStatus } = datosReserva || {};
  const { json_request, status: reservaCurrentStatus } = reservaData || {};
  const { parameters } = json_request || {};

  // Log de los datos para depurar
  // Información de la reserva y tienda para mostrar en resumen
  // console.log("Datos de la reserva:", datosReserva?.data?.nombre_servicio);
  // console.log("Datos de la tienda:", reservaData?.datos_tienda);

  // Verificación antes de acceder a datos_tienda
  const tiendaDescripcion =
    reservaData?.datos_tienda?.descripcion || "Tienda no disponible";

  const handleResumenSubmit = async () => {
    setIsLoading(true);
    const url = process.env.REACT_APP_API_URL_ANULAR_CITA;

    const formDataCancelar = {
      accion: 3,
      cfg_codigo: parameters.cfg_codigo,
      cnv_codigo: parameters.cnv_codigo,
      int_amaterno: parameters.int_amaterno,
      int_apaterno: parameters.int_apaterno,
      int_codigo: parameters.int_codigo,
      int_domicilio: parameters.int_domicilio,
      int_email: parameters.int_email,
      int_nrodocidentidad: parameters.int_nrodocidentidad,
      int_optin: parameters.int_optin,
      int_pnombre: parameters.int_pnombre,
      int_snombre: parameters.int_snombre,
      int_telefono: parameters.int_telefono,
      int_usodatopersonal: parameters.int_usodatopersonal,
      operacion: parameters.operacion,
      rsa_codigo: reservaData.id_reserva,
      rsa_fecha: parameters.rsa_fecha,
      tpc_codigo: parameters.tpc_codigo,
      tpo_codigo: parameters.tpo_codigo,
      int_usoadicional: parameters.int_usoadicional,
    };

    try {
      const response = await axios.post(url, formDataCancelar, {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        setPopupMessage("Su reserva ha sido cancelada con éxito.");
        setPopupVariant("success");
      } else {
        setPopupMessage("La reserva ya se encuentra en estado cancelado.");
        setPopupVariant("danger");
        setTimeout(() => {
          prevStep(); // Navigate back
        }, 3000);
      }
      setShowPopup(true);
    } catch (error) {
      // Error al procesar solicitud de reagendamiento
      console.error("Error al realizar la solicitud:", error);
      setPopupMessage("Hubo un problema al procesar la solicitud.");
      setPopupVariant("danger");
      setShowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="row" id="booking">
      <div className="container">
        <div className="row mb40" id="booking-step-back">
          <button onClick={prevStep} className="btn btn-secondary">
            <i className="fa fa-long-arrow-left"></i> &nbsp; VOLVER
          </button>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-9 pads0-768" id="search-appointment">
            <div className="row" id="search-resume-container">
              {isLoading && (
                <div className="loading-overlay">
                  <div className="spinner"></div>
                </div>
              )}

              <div className="col-12 pads0">
                <div className="col-12 text-center mb20">
                  <h3
                   className={`h3-less
                    ${formData?.cadena === "eco" ? "eco-theme-text" : ""}
                    ${formData?.cadena === "gmo" ? "gmo-theme-text" : ""}
                    `}
                   >
                    Resumen de la reserva
                    </h3>
                </div>

                <div className="col-12 pads0" id="patient-search">
                  <div className="row mb20" id="patient-search-store">
                    <div className="col-12 pads0 mb20">
                      <div className="resume-bar">
                        <b>Tienda Seleccionada</b>
                      </div>
                    </div>
                    <div className="col-md-6 pads0 mb10-768">
                      <div className="row">
                        <div className="col-12">
                          <h6 className="monts-b upper">
                            {reservaData?.datos_tienda?.descripcion}
                          </h6>
                          <p className="mb0">
                            {reservaData?.datos_tienda?.direccion}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 align-self-center text-center">
                      <a
                        href={
                          reservaData?.datos_tienda?.cfg_latitud &&
                          reservaData?.datos_tienda?.cfg_longitud // Verificar que ambas coordenadas existan
                            ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                `${reservaData?.datos_tienda?.cfg_latitud.replace(
                                  ",",
                                  "."
                                )},${reservaData?.datos_tienda?.cfg_longitud.replace(
                                  ",",
                                  "."
                                )}`
                              )}`
                            : "#"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => {
                          if (
                            !reservaData?.datos_tienda?.cfg_latitud ||
                            !reservaData?.datos_tienda?.cfg_longitud
                          ) {
                            e.preventDefault(); // Evitar que el enlace intente navegar si no hay coordenadas válidas
                            // Advertencia: coordenadas de tienda no disponibles
                            console.warn(
                              "Las coordenadas no están disponibles."
                            );
                          }
                        }}
                      >
                        {" "}
                        <p className="text-switch monts-sb blue-bord upper inline-b mb0">
                          Cómo Llegar
                        </p>
                      </a>
                    </div>
                  </div>

                  <div className="row mb-40" id="patient-search-1">
                    <div className="col-12 pads0 mb20">
                      <div className="resume-bar">
                        <b>
                          Reserva de {parameters?.int_pnombre || "N/A"}{" "}
                          {parameters?.int_apaterno || ""}
                        </b>
                      </div>
                    </div>
                    <div className="col-md-6 pads0 mb20 mb0-768">
                      <div className="row">
                        <div className="col-12 mb20">
                          <div className="col-12 mb20">
                            <h6 className="monts-b upper">
                              Propósito de la visita
                            </h6>
                            <p className="mb0 desc-ovw-type">
                              {datosReserva?.data?.nombre_servicio}
                            </p>
                          </div>
                          <div className="col-12 mb20 mb0-768">
                            <h6 className="monts-b upper">Fecha y Hora</h6>
                            <p className="mb0 desc-ovw-date">
                              <span className="date-month">
                                {parameters?.rsa_fecha || "Fecha no disponible"}
                                &nbsp;
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb20">
                      <h6 className="monts-b upper">
                        Información del paciente
                      </h6>
                      <p className="mb0">
                        <strong>Nombre:</strong>{" "}
                        {parameters?.int_pnombre || "N/A"}{" "}
                        {parameters?.int_apaterno || ""}
                      </p>
                      <p className="mb0">
                        <strong>Teléfono:</strong>{" "}
                        {parameters?.int_telefono || "No disponible"}
                      </p>
                      <p className="mb0">
                        <strong>Correo: </strong>{" "}
                        {parameters?.int_email || "No disponible"}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    {/* Reschedule Section */}
                    <div
                      className="col-12 resch-selection-box text-center"
                      style={{ display: "block" }}
                    >
                      <div className="row justify-content-center">
                        <div className="col-md-9 mb10">
                          <p>
                            Si quieres <b>reagendar</b> puedes encontrar los{" "}
                            <b>
                              nuevos horarios disponibles en los siguientes
                              links
                            </b>
                            :
                          </p>
                        </div>
                        <div className="col-md-8 mb40 col-12 pads5">
                          <div
                            onClick={nextStep}
                            className={`cancel-ev-button src-button upper
                              ${formData?.cadena === "eco" ? "button-reagendar-eco" : ""}
                              ${formData?.cadena === "gmo" ? "button-reagendar-gmo" : ""}
                              `}
                            
                          >
                            Reagendar
                          </div>
                        </div>
                        <div className="col-md-9 mt20 text-center">
                          <p>
                            <b>Gracias por confiar</b>
                            <br />
                            Tu salud visual es importante para nosotros
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Cancel Section */}
                    <div className="col-12 cancel-selection-box text-center">
                      <div className="row justify-content-center">
                        <div className="col-md-8 mb40 col-12 pads5">
                          <button
                            onClick={handleResumenSubmit}
                            className={`cancel-ev-button src-button upper 
                              ${formData?.cadena === "eco" ? "eco-theme-button" : ""}
                              ${formData?.cadena === "gmo" ? "gmo-theme-button" : ""}
                              `}
                          >
                            Sí, anular
                          </button>
                        </div>
                        <div className="col-md-9 mb10">
                          <p>
                            Si quieres <b>reagendar</b> puedes encontrar los{" "}
                            <b>
                              nuevos horarios disponibles en los siguientes
                              links
                            </b>
                            :
                          </p>
                        </div>
                        <div className="col-md-4 col-6 pads5">
                          <button className="resch-ev-button src-button upper">
                            Reagendar Examen Visual
                          </button>
                        </div>
                        <div className="col-md-4 col-6 pads5">
                          <button className="resch-ev-button src-button upper">
                            Reagendar Contactología
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Indicador de carga */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {showPopup && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog" role="document">
            <div className={`modal-content border-${popupVariant}`}>
              <div className={`modal-header bg-${popupVariant} text-white`}>
                <h5 className="modal-title">
                  {popupVariant === "success" ? "Éxito" : "Error"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClosePopup}
                ></button>
              </div>
              <div className="modal-body">
                <p>{popupMessage}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClosePopup}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReagendamientoReserva;
